var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy344(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 1.8,
      strokeMiterlimit: 10
    },
    d: " M49.6,18.1c-17.8,0-31.5,13-31.5,30.5c0,9.2,3.8,17.1,9.9,22.6c0.5,0.5,0.8,1.1,0.8,1.8l0.2,5.6c0.1,1.8,1.9,2.9,3.5,2.2l6.3-2.8 c0.5-0.2,1.1-0.3,1.7-0.1c2.9,0.8,5.9,1.2,9.1,1.2c17.8,0,31.5-13,31.5-30.5S67.4,18.1,49.6,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#FFAF00",
      strokeWidth: 1.8,
      strokeMiterlimit: 10
    },
    d: " M30.7,57.6l9.3-14.7c1.5-2.3,4.6-2.9,6.8-1.3l7.4,5.5c0.7,0.5,1.6,0.5,2.3,0l9.9-7.5c1.3-1,3.1,0.6,2.2,2l-9.3,14.7 c-1.5,2.3-4.6,2.9-6.8,1.3l-7.4-5.5c-0.7-0.5-1.6-0.5-2.3,0l-10,7.5C31.5,60.6,29.8,59,30.7,57.6L30.7,57.6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "people"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lamps"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg5673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy344);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-344.908d4cf63925218cc0745e142cb67fb4.svg";
export { ForwardRef as ReactComponent };